// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29HUL","label":"styles_label__3d6Lm"};